import { Divider } from 'antd';
import { ProductListItem } from 'app/components/List';
import { GetOneResponse } from 'app/context/data/types';
import { useOne } from 'app/definitions/hooks/data/useOne';
import React, { useEffect } from 'react';
import { POItemDescriptions } from './descriptions';
import { InspectionPOItem } from '../../types';
import { InspectionCriteria } from './criteria';
import classes from './PoItem.module.scss';

export type POItemProps = {
  id: string | number;
  ordinalNumber?: number;
};

export const POItem = (props: POItemProps) => {
  const { id, ordinalNumber } = props;
  //TODO: Create Type for Product Profile.
  const { data, isLoading, isFetching } = useOne<InspectionPOItem>({
    resource: 'inspections/po-items',
    id,
    queryOptions: {
      selectFromResult: (result) => {
        if (result && result?.data) {
          return {
            ...result,
            data: result?.data?.data
          };
        }
        return result as unknown as GetOneResponse<InspectionPOItem>;
      }
    }
  });
  const productProfile: any = React.useMemo(() => {
    return data?.productProfile ? data.productProfile : {};
  }, [data]);

  return (
    <div className={classes.poItem}>
      <ProductListItem
        bordered
        order={ordinalNumber}
        // className={cn(classes.item, className)}
        image={productProfile.image}
        name={productProfile.name}
        itemNo={productProfile.itemNo || 'N/A'}
        supplier={productProfile?.supplier?.name || 'N/A'}
        factory={productProfile?.factory?.name || 'No Factory Linkage'}
      >
        <POItemDescriptions item={data} />
      </ProductListItem>
      <Divider />
      {!data || isLoading || isFetching ? (
        <div>Loading...</div>
      ) : (
        <InspectionCriteria
          criteria={data?.inspectionCriteria}
          poItem={data}
          poItemId={data?.id}
          loading={isLoading || isFetching}
        />
      )}
    </div>
  );
};
